import React, {useState} from "react";
import Mainheader from "../components/MainHeader/Mainheader";
import {Link, useLocation, useNavigate} from "react-router";
import Nopreview from "../assets/images/Nopreview.svg";
import ExclamationIcon from "../assets/images/exclamation.svg";
import Preview from "../assets/images/preview.svg";
import {loginApi} from "../services/apiService";
import {toast} from "react-toastify";
import {useUserContext} from "../context/UserContext";
import Cookies from "js-cookie";

const Login = () => {
  const {setUserData, setCookiesValue} = useUserContext();
  const navigate = useNavigate();
  const location = useLocation();

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formDataSignin, setFormDataSignin] = useState({
    username: "",
    password: "",
  });

  const [formErrorsSignin, setFormErrorsSignin] = useState({
    username: "",
    password: "",
  });

  const handleChangeSignin = e => {
    const {name, value} = e.target;
    setFormDataSignin({...formDataSignin, [name]: value});
    setFormErrorsSignin({...formErrorsSignin, [name]: ""});
  };

  const handleLogin = async () => {
    try {
      // e.preventDefault();
      if (validateFormSignin()) {
        setIsSubmitting(true);
        let apiRes = await loginApi(formDataSignin);
        let responseData = apiRes;

        if (responseData.data && responseData.data.res == false) {
          //setErrorMessage(responseData.data.msg)
          toast.error(responseData.data.msg || "Something went wrong in server, please try again.", {autoClose: 1500});
          setIsSubmitting(false);
        } else {
          if (responseData.data) {
            if (responseData.data.status) {
              toast.warn(responseData.data.msg, {autoClose: 1500});
              navigate("/verification", {state: {id: responseData.data.data, from: location?.state?.from}});
            } else {
              if (responseData.data.data) {
                localStorage.setItem("doctolikLoginInfo", JSON.stringify(responseData.data.data));
                setUserData(responseData.data.data);
                Cookies.set("doctolikAuthToken", responseData.data?.data?.authorisation?.token, {
                  expires: 7,
                  secure: true, // Ensures the cookie is only sent over HTTPS
                  sameSite: "Strict",
                });
                setCookiesValue(responseData.data?.data?.authorisation?.token);
                toast.success(responseData.data.msg ? responseData.data.msg : "Logged in successfully", {autoClose: 1500});
                if (location?.state?.from) {
                  navigate(location.state.from);
                } else {
                  navigate("/");
                }
              }
            }
          } else {
            toast.error("Something went wrong in server, please try again.", {autoClose: 1500});
          }
        }
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
      setIsSubmitting(false);
    }
  };

  const validateFormSignin = () => {
    let isValid = true;
    const errors = {
      username: "",
      password: "",
    };

    if (formDataSignin.username === "") {
      errors.username = "Please enter your username";
      isValid = false;
    }

    if (formDataSignin.password === "") {
      errors.password = "Please enter your password";
      isValid = false;
    }

    setFormErrorsSignin(errors);
    return isValid;
  };

  const handleforgot = () => {
    // Perform login logic here
    navigate("/forgot-password");
  };

  const handleRegister = () => {
    // Perform login logic here
    navigate("/register");
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const submitLogin = e => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="Main">
      <Mainheader />
      <div className="Fullbody">
        <div className="LoginBox">
          <h3>Login</h3>
          <h4>Welcome Back! </h4>

          {/* <form className="login-form" onSubmit={handleLogin}> */}
          <div className="input-group">
            <input
              type="text"
              placeholder="Username"
              data-testid="form-field-username"
              className={`emailInput ${formErrorsSignin.username ? "inputHaveError" : ""}`}
              name="username"
              value={formDataSignin.username}
              onChange={handleChangeSignin}
              onKeyDown={submitLogin}
            />
            {formErrorsSignin.username && (
              <span className="vaidationError">
                <img className="exclamationIcon" src={ExclamationIcon} /> {formErrorsSignin.username}
              </span>
            )}
          </div>
          <div className="input-group">
            <input
              name="password"
              data-testid="form-field-password"
              value={formDataSignin.password}
              onChange={handleChangeSignin}
              onKeyDown={submitLogin}
              type={passwordVisible ? "text" : "password"}
              placeholder="Password"
              className={`passwordInput ${formErrorsSignin.password ? "inputHaveError" : ""}`}
            />
            {/* <input
                type="password"
                placeholder="Password"
                className="passwordInput"
                required
              /> */}
            <span className="password-icon" onClick={togglePasswordVisibility}>
              <img src={passwordVisible ? Nopreview : Preview} alt="Toggle Password Visibility" />
            </span>
            {formErrorsSignin.password && (
              <span className="vaidationError">
                <img className="exclamationIcon" src={ExclamationIcon} />
                {formErrorsSignin.password}
              </span>
            )}
          </div>

          <Link to="/forgot-password" className="forgot-password" data-testid="forgot-password-testid">
            Forgot Password
          </Link>

          <button type="submit" className="login-button" name="Login" onClick={() => handleLogin()} disabled={isSubmitting} data-testid="login-btn-testid">
            {isSubmitting ? "Please wait..." : "Login"}
          </button>

          <p className="createLink">
            Don’t have an account?{" "}
            <Link to="/register" state={{from: location?.state?.from}}>
              Create Now!
            </Link>
          </p>
          {/* </form> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
